<template><div><h1>VUX V2.6.4 发布日志</h1>
<h2><a href="/zh-CN/components/alert.html">Alert</a></h2>
<ul><li>[feature] 支持属性 mask-z-index 设置遮罩 z-index</li>
</ul>
<h2><a href="/zh-CN/components/calendar.html">Calendar</a></h2>
<ul><li>[feature] 支持格式化值显示 #2023</li>
</ul>
<h2><a href="/zh-CN/components/cell.html">Cell</a></h2>
<ul><li>[feature] 支持属性 align-items</li>
</ul>
<h2><a href="/zh-CN/components/checklist.html">Checklist</a></h2>
<ul><li>[feature] 添加方法 getFullValue 获取值和对应的显示文字 #2022</li>
</ul>
<h2><a href="/zh-CN/components/confirm.html">Confirm</a></h2>
<ul><li>[feature] 支持属性 mask-z-index 设置遮罩 z-index</li>
</ul>
<h2><a href="/zh-CN/components/previewer.html">Previewer</a></h2>
<ul><li>[feature] 方便删除操作，绑定数据减少一张时自动更新示图，有更多图片时切换到下一张，没有时将自动关闭预览</li>
</ul>
<h2><a href="/zh-CN/components/x-dialog.html">XDialog</a></h2>
<ul><li>[feature] 支持属性 mask-z-index 设置遮罩 z-index</li>
</ul>
<h2><a href="/zh-CN/components/close-dialogs.html">CloseDialogs</a></h2>
<ul><li>[feature] 新插件，用于在路由切换时自动关闭所有 plugin 形式打开的弹窗，包括 alert confirm toast loading datetime #2025</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.6.4 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.6.4-256.vue?05558488